import styled from "styled-components";
import React from "react";
import { IconMenu2 } from "@tabler/icons-react";
import { ActionIcon } from "@mantine/core";

const MenuButtonContainer = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: ${(p) => (p.isLoggedIn ? "none" : "block")};
  }
`;

//-------------------------------------

export const LogoContainer = styled.div`
  align-items: center;
  padding: 0 0.5rem;
  display: flex;
`;

export const Logo = styled.img`
  height: var(--logo-height);
  width: var(--logo-width);
  @media (max-width: 576px) {
    height: var(--logo-height-xs);
    width: var(--logo-width-xs);
  }
`;

export const MenuButton = (props) => (
  <MenuButtonContainer {...props}>
    <ActionIcon
      onClick={() => props.toggle()}
      aria-label={props.label}
      color="dark"
    >
      <IconMenu2 />
    </ActionIcon>
  </MenuButtonContainer>
);
